import { find, propEq } from 'ramda';
export function createValidation() {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    function validate(value) {
        return validators
            .filter(function (validator) { return !validator.isValid(value); })
            .map(function (validator) { return ({
            id: validator.id,
            message: validator.message,
        }); });
    }
    function isValid(value) {
        return validate(value).length === 0;
    }
    return {
        validate: validate,
        isValid: isValid,
    };
}
export var createValidator = function (id, isValid, message) { return ({
    id: id,
    isValid: isValid,
    message: message,
}); };
export var focusFieldValidatorFn = function () {
    return function (field, validatorFn) {
        return function (value) { return validatorFn(value[field], value); };
    };
};
export var createFieldValidator = function () {
    return function (field, isValid, message) { return ({
        message: message,
        id: field,
        isValid: focusFieldValidatorFn()(field, isValid),
    }); };
};
export function errorMessage(validationErrors, id, language) {
    var error = find(propEq('id', id), validationErrors || []);
    return error && error.message[language];
}
export function ifError(validationErrors, id, value) {
    var error = find(propEq('id', id), validationErrors || []);
    return error && value;
}
export var regexValidatorFn = function (regex) { return function (str) { return regex.test(str); }; };
export var isBlank = regexValidatorFn(/^\s*$/);
export var isValidPhoneNumber = regexValidatorFn(/^[\d-+\s]{5,30}$/);
export var isValidEmail = regexValidatorFn(/^\S+@\S+\.\S+$/);
export var isValidYTunnus = regexValidatorFn(/^[\d]{7}-[\d]$/);
export var isValidZipCode = regexValidatorFn(/^[\d]{5}$/);
